import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { PremiumGate } from "./premium";
import { EnvBanner } from "@blog/spa-common/components/EnvBanner";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* La puerta envuelve a <App/> y no vive dentro: así el compilador de
        Typst (27 MiB de wasm que se cargan al montar) ni siquiera se pide
        cuando la herramienta está cerrada. */}
    <PremiumGate>
      <App />
    </PremiumGate>
    {/* Vacío en producción (VITE_ENV_LABEL sin definir en .env.production). */}
    <EnvBanner label={import.meta.env.VITE_ENV_LABEL} />
  </React.StrictMode>,
);
